module.exports = __webpack_public_path__ + "img/pic28.4aff5776.png";